import React, { useEffect, useState } from 'react';
import DashboardLayout from './DashboardLayout';
import CampaignsManagement from './Campaigns/Manage_campaigns';
import AccountabilityManagement from './Campaigns/Accountability';
import { toast } from 'react-toastify';
import baseURL from '../config';
import PageLoader from '../../../Reusable/PageLoader';
const ManageCampaigns = () => {
    const [campaigns, setCampaigns] = useState([]);
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchAllData = async () => {
        setLoading(true);
        try {
                    // Simulate a small delay for demo purposes, if needed
        // await new Promise(resolve => setTimeout(resolve, 4000));
            const [campaignsResponse, activitiesResponse] = await Promise.all([
                fetch(`${baseURL}/admin/campaigns`, { credentials: 'include' }),
                fetch(`${baseURL}/admin/accountability`, { credentials: 'include' })
            ]);

            if (!campaignsResponse.ok) {
                const errorData = await campaignsResponse.json();
                throw new Error(errorData.message || 'Failed to fetch campaigns.');
            }
            if (!activitiesResponse.ok) {
                const errorData = await activitiesResponse.json();
                throw new Error(errorData.message || 'Failed to fetch accountability activities.');
            }

            const campaignsData = await campaignsResponse.json();
            const activitiesData = await activitiesResponse.json();

            setCampaigns(campaignsData);
            setActivities(activitiesData);
        } catch (err) {
            console.error("Error fetching data:", err);
            toast.error(err.message || "An unexpected error occurred while fetching data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllData();
    }, []);

    const handleUpdateCampaigns = () => {
        fetchAllData();
    };

    if (loading) {
        return (
            <DashboardLayout>
                <PageLoader message="Loading campaigns ..." />
            </DashboardLayout>
        );
    }

    return (
        <DashboardLayout>
            <CampaignsManagement campaigns={campaigns} onUpdate={handleUpdateCampaigns} />
            <AccountabilityManagement activities={activities} />
        </DashboardLayout>
    );
};

export default ManageCampaigns;